import { Button, Col, Dropdown, Row } from "antd";
import React, { useCallback, useMemo } from "react";
import { createUseStyles } from "react-jss";
import { useNavigate } from "react-router";
import { DeviceType } from "../../utils/constants";
import { useMetaContext } from "../core/contexts/MetaContextProvider";
import { CustomContainer } from "./components/container";
import { _STYLES } from "./utils/customStyles";

import { MenuOutlined } from "@ant-design/icons";

const {
  navBarWrap,
  navBarHeader,
  navLink,
  customFont,
  logo,
  navBarShadow,
  navDropdown,
  w100,
  navBtn,
} = _STYLES;
const useStyles = createUseStyles({
  navBarWrap,
  navBarHeader,
  navLink,
  customFont,
  logo,
  navBarShadow,
  navDropdown,
  w100,
  navBtn,
});

const NavBar = ({ shadowed = false }) => {
  const { deviceType } = useMetaContext();

  const isResponsive = deviceType !== DeviceType.pc;

  const classes = useStyles();

  const navigate = useNavigate();

  const _NAVITEMS = useMemo(
    () => [
      {
        name: "Home",
        link: "/",
      },
      {
        name: "Blogs",
        link: "/blogs",
      },
      {
        name: "For Vets",
        link: "/clinic-registration",
      },
      {
        name: "Support",
        link: "/support",
      },
      {
        name: "Contact",
        link: "/contact",
      },
      {
        name: "Privacy Policy",
        link: "/privacy-policy",
      },
    ],
    []
  );

  const handleScrollToDownloadSection = useCallback(() => {
    navigate("/#download");
  }, [navigate]);

  const mobileMenu = useCallback(() => {
    const items = _NAVITEMS.map((item, index) => ({
      key: `navigationItem-${index}`,
      label: (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          onClick={() => navigate(item.link, { preventScrollReset: true })}
          className={classes.navLink}
        >
          {item.name}
        </a>
      ),
    }));
    items.push({
      key: "navigationItem-download",
      label: (
        <Button
          className={classes.customFont}
          block
          type="primary"
          shape="round"
          onClick={handleScrollToDownloadSection}
        >
          Download Now
        </Button>
      ),
    });

    return (
      <Dropdown
        menu={{
          items,
        }}
        placement="topRight"
        arrow
        rootClassName={classes.navDropdown}
      >
        <Button className={classes.navBtn}>
          <MenuOutlined />
        </Button>
      </Dropdown>
    );
  }, [
    _NAVITEMS,
    classes.customFont,
    classes.navBtn,
    classes.navDropdown,
    classes.navLink,
    handleScrollToDownloadSection,
    navigate,
  ]);

  return (
    <Col
      className={`${classes.navBarWrap} ${
        shadowed ? classes.navBarShadow : ""
      }`}
    >
      <CustomContainer className={classes.w100}>
        <Row justify="space-between" align="middle">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a onClick={() => navigate("/")}>
            <Row gutter={[16, 0]} align="middle">
              <Col>
                <img className={classes.logo} src="/images/logo.png" alt="" />
              </Col>
              <Col>
                <h4 className={classes.navBarHeader + " " + classes.customFont}>
                  Unstray Me
                </h4>
              </Col>
            </Row>
          </a>

          {isResponsive ? (
            mobileMenu()
          ) : (
            <Row align={"middle"} gutter={[24, 0]}>
              {_NAVITEMS.map((item, index) => (
                <Col key={"nav-" + index}>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => navigate(item.link)}
                    className={classes.navLink}
                  >
                    {item.name}
                  </a>
                </Col>
              ))}
              <Col>
                <Button
                  className={classes.customFont}
                  block
                  type="primary"
                  shape="round"
                  onClick={handleScrollToDownloadSection}
                >
                  Download Now
                </Button>
              </Col>
            </Row>
          )}
        </Row>
      </CustomContainer>
    </Col>
  );
};

export default NavBar;
